import React, { useState } from 'react';
import { rgb2Hex } from '../../../../utils/javascript';
import { ChartColorPickerContainer } from './styles';
import ColorPicker from '../../../../artboard/ColorPicker';
import { Button, Icon, Popover, Tooltip } from 'antd';

export const ChartColorPicker = ({ fontColor, onColorChange, removeColorPalette, index, deleteColorPicker }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [showPrimaryPopover, setShowPrimaryPopover] = useState(false);

  return (
    <Popover
      content={<Tooltip
        title={'Delete'}
        placement="top"
      >
        <Button onClick={() => {
          removeColorPalette(index);
          setShowPrimaryPopover(false)
        }}>
          <Icon type="delete" />          
        </Button>
      </Tooltip>}
      trigger="hover"
      overlayClassName="chart-hor-popover"
      visible={showPrimaryPopover}
      onVisibleChange={vis => {
        deleteColorPicker &&  setShowPrimaryPopover(vis);        
      }}
    >
      <ChartColorPickerContainer
        style={{
          backgroundColor: rgb2Hex(fontColor),
        }}
        onClick={() => setShowPicker(true)}
      >
        {showPicker && (
          <ChartColorPickerContainer>
            <ColorPicker
              onChange={color => onColorChange(color, fontColor)}
              onBlur={() => setShowPicker(false)}
              color={rgb2Hex(fontColor)}
              qlEditor={true}
            />
          </ChartColorPickerContainer>
        )}
      </ChartColorPickerContainer>
    </Popover>
  );
};
